import Vue from 'vue';
import DeviceDetector from "device-detector-js";
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI, { Loading } from 'element-ui';
import { sleep, queryUrl, getBaseInviteCode } from '@/utils/util';
import { report } from '@/api/report';
import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';

const unfiltered = localStorage.getItem('unfiltered') || '';

if (!unfiltered) {
  localStorage.setItem('unfiltered', '0');
}

Vue.use(ElementUI, {locale});
Vue.config.productionTip = false;

async function getUserInfo() {
  const loading = Loading.service({
    fullscreen: true,
    customClass: 'app-loading',
    background: '#1c1d21'
  });
  const { invite_code } = queryUrl(window.location.href);
  const defaultInviteCode = getBaseInviteCode();

  if (invite_code) {
    localStorage.setItem('invite_code', invite_code);
  }
  else {
    localStorage.setItem('invite_code', defaultInviteCode);
  }
  
  await sleep(10);
  await store.dispatch('updateUserInfo');
  store.dispatch('updateInviteCode', {
    inviteCode: invite_code || defaultInviteCode
  });
  loading.close();
}

Promise.all([
  getUserInfo()
]).then(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
});

try {
  window.APP_ENV = {
    ...process.env
  };
  console.log(process.env);

  const deviceDetector = new DeviceDetector();
  const deviceInfo = deviceDetector.parse(window.navigator.userAgent);
  
  report({
    event_type: 'app_os',
    event_value: `${deviceInfo.os.name}&${deviceInfo.os.version}`
  });
}
catch(err) {}
